export const transformBankAccount = _ref => {
  let {
    id,
    name,
    account_number,
    routing_number,
    is_default,
    user_id,
    user_address_id,
    spending_type
  } = _ref;
  return {
    id,
    name,
    accountNumber: account_number,
    routingNumber: routing_number,
    isDefault: !!is_default,
    userId: user_id,
    userAddressId: user_address_id,
    spendingType: spending_type
  };
};
export const transformBankAccounts = bankAccounts => bankAccounts.map(transformBankAccount);